/**
 * Contact form (sections/contact-main.liquid): keeps the hidden "Route" field in step with the
 * "Contacting About" dropdown, so every form email carries a short, stable line such as
 * "Route: tool-repair" that mail rules can key on. Each option carries its route in data-route.
 * A link such as /pages/contact?topic=opening-a-t-e-account opens the form with that topic chosen.
 */
(() => {
  const select = document.getElementById('ContactTopic');
  const route = document.getElementById('ContactRoute');
  if (!select || !route) return;
  const sync = () => {
    const option = select.options[select.selectedIndex];
    if (option && option.dataset.route) route.value = option.dataset.route;
  };
  const wanted = new URLSearchParams(window.location.search).get('topic');
  if (wanted) {
    const index = [...select.options].findIndex((option) => option.dataset.route === wanted);
    if (index > -1) select.selectedIndex = index;
  }
  select.addEventListener('change', sync);
  select.form?.addEventListener('submit', sync);
  sync();
})();
